import React from 'react';
import ArrowDownCircleIcon from '@atlaskit/icon/glyph/arrow-down-circle';
import ArrowUpCircleIcon from '@atlaskit/icon/glyph/arrow-up-circle';
import type { Trend } from '../../types.tsx';
import { getTrendBackgroundColor } from '../../utils/compare-period.tsx';

type Props = {
	trend: Trend;
};

export const TrendIcon = ({ trend }: Props) => {
	const size = 'small';

	switch (trend) {
		case 'over':
			return (
				// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
				<ArrowUpCircleIcon
					size={size}
					primaryColor={getTrendBackgroundColor('over').backgroundColor}
					label=""
					testId="software-cycle-time-breakdown-report.common.ui.trend-icon.arrow-up-circle-icon"
				/>
			);
		case 'under':
			return (
				// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
				<ArrowDownCircleIcon
					size={size}
					primaryColor={getTrendBackgroundColor('under').backgroundColor}
					label=""
					testId="software-cycle-time-breakdown-report.common.ui.trend-icon.arrow-down-circle-icon"
				/>
			);
		case 'equal':
			return null;
		default:
			// prettier-ignore
			// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
			(trend as never);
			throw new Error('Unknown trend is given to TrendIcon component');
	}
};
